/* ============================================================
   EPIC · Klaviyo auto-capture
   Conecta TODOS los campos de correo de marketing (newsletter, footer,
   contacto, formularios EPIC) a Klaviyo, sin tocar cada sección.
   Usa la config pública window.EPIC_KLAVIYO = { key, list }.
   NO captura logins/cuenta/contraseña (eso no es opt-in de marketing).
   ============================================================ */
(function () {
  if (window.__epicKlaviyoAuto) return; window.__epicKlaviyoAuto = true;

  function cfg() { return window.EPIC_KLAVIYO || {}; }
  function done(email) { try { return localStorage.getItem('epicKlaviyoDone_' + email) === 'true'; } catch (e) { return false; } }
  function valid(em) { return em && /\S+@\S+\.\S+/.test(em); }

  function sub(email, props) {
    if (!valid(email) || done(email)) return;
    if (window.EpicKlaviyo && window.EpicKlaviyo.add) { window.EpicKlaviyo.add(email, props); return; }
    /* Fallback directo a la API cliente de Klaviyo (key/list públicos) */
    var c = cfg(); if (!c.key || !c.list) return;
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(c.key), {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: (props && props.fuente) || 'web EPIC', profile: { data: { type: 'profile', attributes: { email: email, properties: props || {} } } } }, relationships: { list: { data: { type: 'list', id: c.list } } } } })
      }).then(function () { try { localStorage.setItem('epicKlaviyoDone_' + email, 'true'); } catch (e) {} }).catch(function () {});
    } catch (e) {}
  }

  /* ¿Este input/form es de marketing (newsletter/contacto) y NO de login? */
  function isMarketing(el) {
    var form = el.closest ? el.closest('form') : null;
    var scope = (el.closest && el.closest('[data-klaviyo-capture],[data-epic-klaviyo],.epic-newsletter,.epic-nl,.ehub__news,footer,.footer,.newsletter,#newsletter,[class*="newsletter"],[class*="contact"],[class*="__contact"]')) || null;
    if (!scope && form) {
      var act = (form.getAttribute('action') || '').toLowerCase();
      if (/contact|newsletter|customer\/contact/.test(act)) scope = form;
    }
    if (!scope) return false;
    /* Evita doble disparo: si la sección ya tiene su propio Klaviyo (data-klaviyo-key),
       ella se encarga (y el dedupe por email igual lo cubriría). */
    if (el.closest && el.closest('[data-klaviyo-key]')) return false;
    /* Excluir login / registro de cuenta / recuperación / pago */
    var blockSel = '[action*="/account/login"],[action*="/account/register"],[action*="/account/recover"],[action*="customer_login"],[id*="login"],[class*="login"],[class*="register"],[class*="recover"],[class*="password"],[class*="checkout"],[name="customer[password]"]';
    if (form && form.matches && form.matches(blockSel)) return false;
    if (form && form.querySelector && form.querySelector('input[type="password"]')) return false; /* tiene password = no marketing */
    if (el.closest && el.closest(blockSel)) return false;
    return true;
  }

  function emailIn(form) {
    var i = form.querySelector('input[type="email"], input[name*="email" i], input[name="contact[email]"]');
    return i ? (i.value || '').trim() : '';
  }

  /* 1) Captura al enviar cualquier formulario de marketing con correo (no bloquea el envío nativo) */
  document.addEventListener('submit', function (e) {
    try {
      var form = e.target; if (!form || form.nodeName !== 'FORM') return;
      var email = emailIn(form);
      if (email && isMarketing(form)) sub(email, { fuente: 'form-' + ((form.getAttribute('action') || 'web').split('/').pop() || 'web') });
    } catch (err) {}
  }, true);

  /* 2) Captura al salir de un campo de correo de marketing (por si no hay submit clásico) */
  document.addEventListener('blur', function (e) {
    try {
      var el = e.target; if (!el || (el.type !== 'email' && !/email/i.test(el.name || ''))) return;
      if (!isMarketing(el)) return;
      var email = (el.value || '').trim();
      if (valid(email)) sub(email, { fuente: 'campo-correo' });
    } catch (err) {}
  }, true);
})();
